export default {
  pagination: {
    page: 1,
    limit: 500,
  },
};
